import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

interface MassMeasurementResultView {
  groupIndex: number;
  measurementIndex: number;
  unit: string;
  calculation: any;
  formula: any;
  result: any;
  capabilityProof: any;
  complianceAssessment: any;
}

@Component({
  selector: 'app-data-entity-mass-certificate-result',
  templateUrl: './DataEntityMassCertificateResult.component.html',
  styleUrls: ['./DataEntityMassCertificateResult.component.scss']
})
export class DataEntityMassCertificateResultComponent implements OnChanges {
  @Input() result: any = null;
  @Input() certificateFilePath: string = null;
  @Input() uncertaintyReportFilePath: string = null;
  @Input() isDownloading = false;
  @Output() downloadCertificate = new EventEmitter<void>();
  @Output() downloadReport = new EventEmitter<void>();

  measurementResults: MassMeasurementResultView[] = [];
  expandedRows: boolean[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.result) {
      this.measurementResults = this.buildMeasurementResults(this.result);
      this.expandedRows = this.measurementResults.map((_item, index) => index === 0);
    }
  }

  toggle(index: number): void { this.expandedRows[index] = !this.expandedRows[index]; }
  trackByMeasurement(index: number): number { return index; }
  trackByIndex(index: number): number { return index; }

  formatValue(value: any): string {
    return value === null || value === undefined || value === '' ? '—' : String(value);
  }

  booleanLabel(value: any): string {
    return value === true ? 'قابل قبول' : value === false ? 'غیرقابل قبول' : 'محاسبه نشده';
  }

  statusClass(value: any): string {
    return value === true ? 'certificate-status--accepted'
      : value === false ? 'certificate-status--rejected' : 'certificate-status--unknown';
  }

  property(source: any, pascalName: string): any {
    if (!source) { return null; }
    if (source[pascalName] !== undefined) { return source[pascalName]; }
    const camelName = pascalName.charAt(0).toLowerCase() + pascalName.slice(1);
    return source[camelName] !== undefined ? source[camelName] : null;
  }

  array(source: any, propertyName: string): any[] {
    const value = this.property(source, propertyName);
    return Array.isArray(value) ? value : [];
  }

  private buildMeasurementResults(certificate: any): MassMeasurementResultView[] {
    const calculationGroups = this.array(certificate, 'MassCalculationResult');
    const modelGroups = this.array(certificate, 'Model');
    const views: MassMeasurementResultView[] = [];

    calculationGroups.forEach((calculationGroup, groupIndex) => {
      const calculations = this.array(calculationGroup, 'Calculations');
      const unit = this.property(calculationGroup, 'Unit');
      const modelGroup = modelGroups.find(item => this.property(item, 'Unit') === unit) || modelGroups[groupIndex];
      const gufModel = this.property(modelGroup, 'GufModel') || modelGroup;
      const formulas = this.array(gufModel, 'Formulas');

      calculations.forEach((calculation, measurementIndex) => {
        const formula = this.property(calculation, 'Formula') || formulas[measurementIndex] || {};
        const formulaResult = this.property(calculation, 'Result') || this.property(formula, 'Result') || {};
        views.push({
          groupIndex,
          measurementIndex,
          unit: this.property(calculation, 'Unit') || unit,
          calculation,
          formula,
          result: formulaResult,
          capabilityProof: this.property(calculation, 'CapabilityProof') || this.property(formulaResult, 'CapabilityProof'),
          complianceAssessment: this.property(calculation, 'ComplianceAssessment') || this.property(formulaResult, 'ComplianceAssessment')
        });
      });
    });

    return views;
  }
}
